import React, { memo } from 'react';
import { Box, Heading, Button, Image } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import LogoBarber from '../../assets/Logo-Barber.png';

const CheckoutHeader = memo(() => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/menu'); // Navega diretamente para o Menu Principal
  };

  return (
    <Box>
      <Box
        position="sticky"
        top={0}
        zIndex={10}
        bg="linear-gradient(180deg, rgba(26,32,44,0.95) 0%, rgba(26,32,44,0.8) 100%)"
        backdropFilter="blur(10px)"
        px={4}
        py={3}
        mb={4}
        borderRadius="xl"
        boxShadow="lg"
      >
        <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
          <Heading size="lg" color="white">Checkout</Heading>
          <Button
            variant="solid"
            onClick={handleBack}
            bg="yellow.400"
            color="gray.800"
            _hover={{ bg: 'yellow.500' }}
            _active={{ bg: 'yellow.600' }}
            size="lg"
            borderRadius="xl"
            px={6}
          >
            Voltar
          </Button>
        </Box>
      </Box>
      
      {/* Logo centralizada com tamanho aumentado */}
      <Box w="100%" display="flex" alignItems="center" justifyContent="center" mt={6} mb={8}>
        <Image 
          src={LogoBarber} 
          alt="Logo Barbearia" 
          height="160px"
          objectFit="contain"
          filter="drop-shadow(0 4px 12px rgba(0, 0, 0, 0.6))"
          transition="all 0.3s ease"
        />
      </Box>
      
      <Heading 
        color="yellow.400" 
        fontSize={{ base: '3xl', md: '4xl' }} 
        textAlign="center" 
        mb={8} 
        letterSpacing="1px" 
        fontWeight="extrabold" 
        textShadow="0 2px 12px rgba(0, 0, 0, 0.5)"
      >
        Finalizar Atendimento
      </Heading>
    </Box>
  );
});

export default CheckoutHeader;
